import { annotatorClient } from './annotatorClient';
import type { BoundingBox } from '../types/annotator';

export async function getAnnotations(projectId: number, imageId: number): Promise<BoundingBox[]> {
  const data = await annotatorClient.get<any[]>(`/projects/${projectId}/images/${imageId}/annotations/`);
  return data.map((a) => ({ ...a, width: a.box_width, height: a.box_height }));
}

export async function saveAnnotations(
  projectId: number,
  imageId: number,
  boxes: Omit<BoundingBox, 'id' | 'image_id' | 'label'>[],
): Promise<BoundingBox[]> {
  const payload = {
    annotations: boxes.map((b) => ({
      label_id: b.label_id,
      x_center: b.x_center,
      y_center: b.y_center,
      box_width: b.width,
      box_height: b.height,
    })),
  };
  const data = await annotatorClient.put<any[]>(`/projects/${projectId}/images/${imageId}/annotations/`, payload);
  return data.map((a) => ({ ...a, width: a.box_width, height: a.box_height }));
}
